module.exports = __webpack_public_path__ + "img/40_38_027_264.ebf546be.jpg";